import React, { useEffect } from 'react';
import Label from 'components/_utility/Label';
import { formatFittingTime } from 'helpers/utilities';
import cloudinary from 'helpers/cloudinary';
import usePrice from 'src/hooks/usePrice';
import Wrench from 'src/assets/icons/wrench.svg';
import {
  Wrap,
  CardsWrap,
  ButtonWrap,
  Card,
  ImageWrap,
  ImageOuter,
  Image,
  Name,
  Price,
  FittingTime,
  Button,
  DetailsWrap,
  PriceTimeWrap,
} from './AccessoryChoiceGroup.styled';
import 'objectFitPolyfill';

const AccessoryChoiceItem = ({ id, onChoose, selected, accessories, noChoice = false }) => {
  const formatPrice = usePrice();

  useEffect(() => {
    window.objectFitPolyfill();
  }, []);

  return (
    <Wrap>
      <CardsWrap>
        {accessories.map(accessory => (
          <Card key={accessory.id}>
            {accessory.images.length ? (
              <ImageWrap>
                <ImageOuter>
                  <Image
                    src={cloudinary(accessory.images[0].src, 'c_thumb,w_180')}
                    alt={accessory.images[0].alt}
                    data-object-fit
                  />
                </ImageOuter>
              </ImageWrap>
            ) : null}
            <DetailsWrap>
              <Name>{accessory.name}</Name>
              <PriceTimeWrap>
                <Price>{accessory.price ? formatPrice(accessory.price) : accessory.priceLocalised}</Price>
                <FittingTime>
                  <Wrench /> {formatFittingTime(accessory.fittingTime)}
                </FittingTime>
              </PriceTimeWrap>
            </DetailsWrap>
          </Card>
        ))}
      </CardsWrap>
      {!noChoice ? (
        <ButtonWrap>
          <Button onClick={() => onChoose(selected ? null : id)} active={selected}>
            {selected ? <Label name="selectedLabel" /> : <Label name="selectLabel" />}
          </Button>
        </ButtonWrap>
      ) : null}
    </Wrap>
  );
};

export default AccessoryChoiceItem;
